import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';

import { AdminService } from '../../../services';

@Component({
    selector: 'sn-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
    @Input() scope: string;
    @Output() selectEvent = new EventEmitter();

    public users: Array<any> = [];
    public allUsers: Array<any>;
    public isUserLoaded: boolean = false;

    searchText = "";
    items = [];
    itemCount = 0;
    itemResource = new DataTableResource(this.users);
    lastParams;

    filterParams = ["first_name", "last_name", "title", "team_name", "email"];

    reloadItems(params) {
        //console.log(params);
        this.lastParams = params;
        this.itemResource.query(params).then(
            items => {
                this.items = items;
                // console.log(items);
            }
        );
        this.itemResource.count().then(count => this.itemCount = count);
    }

    constructor(
        private adminService: AdminService
    ) { }

    ngOnInit() {
        // this.allUsers = this.adminService.getAllUsers();
        // if (this.allUsers == undefined) this.allUsers = [];
        // this.users = this.allUsers;
        // this.itemResource = new DataTableResource(this.users);
        // this.itemResource.count().then(count => this.itemCount = count);
        // this.isUserLoaded = this.users.length > 0;

        this.adminService.allUserLoaded.subscribe(bLoaded => {
            if (bLoaded) {
                this.allUsers = this.adminService.getAvailableUsers(this.scope);
                this.users = this.allUsers;
                this.itemResource = new DataTableResource(this.users);
                this.itemResource.count().then(count => this.itemCount = count);
                this.isUserLoaded = true;
            }
        })
    }

    onChange($event) {
        var filteredUsers = [];
        this.allUsers.forEach(
            u => {
                for (var i = 0; i < this.filterParams.length; i++) {
                    var p = this.filterParams[i];
                    //console.log("user id: " + u["ID"] + " filter: " + p);
                    if (u[p].toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0) {
                        filteredUsers.push(u);
                        break;
                    }
                }
            }
        );
        this.users = filteredUsers;
        this.itemResource = new DataTableResource(this.users);
        this.lastParams.offset = 0;
        this.reloadItems(this.lastParams);
    }

    rowClick(rowEvent) {
        this.selectEvent.emit({ selectedItem: rowEvent.row.item });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/list/user-list/user-list.component.ts